<template>
  <div>
    <table-default
      :table-data="campaigns"
      default-sort="label"
      empty-message="You don't have any campaigns."
      is-scrollable
      is-small-text
      :is-loading="isLoading"
    >
      <b-table-column label="Campaign" field="label" sortable v-slot="props">
        {{ props.row.label }}
      </b-table-column>

      <b-table-column label="Cost" field="cost" numeric sortable v-slot="props">
        {{ formatCurrency(props.row.cost) }}
      </b-table-column>

      <b-table-column label="$/Lead" field="cost_per_lead" numeric sortable v-slot="props">
        {{ formatCurrency(props.row.cost_per_lead) }}
      </b-table-column>

      <b-table-column label="$/Contracted" field="cost_per_contracted" numeric sortable v-slot="props">
        {{ formatCurrency(props.row.cost_per_contracted) }}
      </b-table-column>

      <b-table-column label="$/Closed" field="cost_per_closed" numeric sortable v-slot="props">
        {{ formatCurrency(props.row.cost_per_closed) }}
      </b-table-column>

      <b-table-column label="Leads" field="leads_count" numeric sortable v-slot="props">
        {{ formatValue(props.row.leads_count) }}
      </b-table-column>

      <b-table-column label="Appts" field="appts_count" numeric sortable v-slot="props">
        {{ formatValue(props.row.appointment_count) }}
      </b-table-column>

      <b-table-column label="Offers" field="offers_count" numeric sortable v-slot="props">
        {{ formatValue(props.row.offers_count) }}
      </b-table-column>

      <b-table-column label="Contracted" field="contracted_count" numeric sortable v-slot="props">
        {{ formatValue(props.row.contracted_count) }}
      </b-table-column>

      <b-table-column label="Closed" field="closed_count" numeric sortable v-slot="props">
        {{ formatValue(props.row.closed_count) }}
      </b-table-column>

      <b-table-column label="Projected Profit" field="projected_profit" numeric sortable v-slot="props">
        {{ formatCurrency(props.row.projected_profit) }}
      </b-table-column>

      <b-table-column label="Actual Profit" field="actual_profit" numeric sortable v-slot="props">
        {{ formatCurrency(props.row.actual_profit) }}
      </b-table-column>

      <b-table-column label="ROI" field="roi" numeric sortable v-slot="props">
        {{ formatPercent(props.row.roi) }}
      </b-table-column>

      <b-table-column label="Avg Days to Profit" field="avg_time_profit" numeric sortable v-slot="props">
        {{ formatValue(props.row.avg_days_to_profit) }}
      </b-table-column>
    </table-default>
  </div>
</template>

<script>
import utils from "../../../services/utils";

export default {
  name: "StatsCampaignsTable",
  props: {
    campaigns: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    formatValue(value) {
      if (!value) return '--'
      return value
    },
    formatCurrency(value) {
      if (!value || value === '0.00') return '--'
      return utils.formatCurrency(value)
    },
    formatPercent(value) {
      if(!value) return '--'
      return `${utils.formatDigit(value)}%`
    },
  }
}
</script>

<style scoped lang="scss">

</style>
